import { render } from "./HistorialFechas.vue?vue&type=template&id=67eb6d1a"
import script from "./HistorialFechas.vue?vue&type=script&lang=js"
export * from "./HistorialFechas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__